import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const deleteOwner = async (id, workshop, setError, logoutHandler) => {
  const payload = { employee_profile_id: id };
  await apiCaller
    .post(`${URLS.EMPLOYEE_REMOVE_OWNER}${workshop}/`, payload)
    .then((resp) => {
      if (resp.data !== undefined) {
        setError(null);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default deleteOwner;
